import { createContext, useContext } from 'react';

import type { PaginationProps } from './pagination/pagination.types';

/**
 * Context value for Pagination components to share state
 */
export type PaginationContextValue = Pick<
  PaginationProps,
  'count' | 'itemsPerPage' | 'itemsPerPageOptions' | 'onItemsPerPageChange' | 'onPageChange' | 'page'
>;

const PaginationContext = createContext<null | PaginationContextValue>(null);

export const usePaginationContext = (): null | PaginationContextValue => {
  return useContext(PaginationContext);
};

export default PaginationContext;
